export const QUICKHOOK_STORAGE_KEY = 'aifit_quickhook_intent';

/**
 * Persist first-contact QuickHook answers so registration/Núcleo can reuse them.
 */
export function saveQuickHookIntent(intent) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(
      QUICKHOOK_STORAGE_KEY,
      JSON.stringify({
        ...intent,
        saved_at: new Date().toISOString(),
      })
    );
  } catch {
    // Ignore quota / private mode failures.
  }
}

export function readQuickHookIntent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(QUICKHOOK_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearQuickHookIntent() {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(QUICKHOOK_STORAGE_KEY);
  } catch {
    // Ignore.
  }
}
